import './TileButton.scss';

import * as React from 'react';

import SlButton from '@shoelace-style/shoelace/dist/react/button';

export interface TileButtonProps
  extends Pick<
    React.ComponentProps<typeof SlButton>,
    'onClick' | 'disabled' | 'aria-label'
  > {
  icon: React.ReactNode;
  title: React.ReactNode;
  description?: string;
  className?: string;
  layout?: 'vertical' | 'horizontal';
}

export const TileButton = ({
  icon,
  title,
  description,
  className,
  layout = 'vertical',
  ...rest
}: TileButtonProps) => {
  return (
    <div
      className={`tile-button ${
        layout === 'horizontal' ? 'tile-button--horizontal' : ''
      }`}
      data-testid="tile-button"
    >
      <SlButton
        className={`flex ${
          layout === 'horizontal' ? 'w-full' : ''
        } ${className}`}
        {...rest}
      >
        <div slot="prefix" className="flex tile-button__icon">
          {icon}
        </div>
        <div className="tile-button__content">
          <div className="tile-button__title">{title}</div>
          {description && (
            <div className="tile-button__description">{description}</div>
          )}
        </div>
      </SlButton>
    </div>
  );
};
